import { chartUtil } from "../../../common";
import { Card, Stack, Typography } from "@mui/material";

import {
  BoZoneSparkline,
  BoZoneTrendPill,
  BoZoneTrendDirection,
} from "../../layer01";
import { direction2Chip } from "../../layer01/BoZoneTrendPill/BoZoneTrendPill";

export type IScoreCardOrientation = "row" | "column";

const orientation2Flex: Record<IScoreCardOrientation, string> = {
  row: "1 1 0",
  column: "0 0 auto",
};

type BoZoneScoreCardProps = {
  orientation?: IScoreCardOrientation;
  title: string;
  direction: BoZoneTrendDirection;
  value: string;
  summary: string;
  period: string;
  points: chartUtil.ChartPoints;
};

export const BoZoneScoreCard = (props: BoZoneScoreCardProps) => (
  <Card
    sx={{
      flex: props.orientation
        ? orientation2Flex[props.orientation]
        : {
            xs: orientation2Flex.column,
            sm: orientation2Flex.row,
          },
      minWidth: 0,
      paddingTop: "1rem",
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
      paddingBottom: "1.5rem",
    }}
  >
    <Stack direction="column" rowGap="1rem">
      <Stack
        direction="row"
        columnGap=".5rem"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="cardTitle" minWidth={0} noWrap>
          {props.title}
        </Typography>
        <BoZoneTrendPill direction={props.direction} value={props.value} />
      </Stack>
      <Stack
        direction="row"
        columnGap=".75rem"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="column" rowGap=".25rem" minWidth={0}>
          <Typography variant="cardSectionTitle">{props.summary}</Typography>
          <Typography variant="cardSubtitle" color="#53565A">
            {props.period}
          </Typography>
        </Stack>
        <BoZoneSparkline
          points={props.points}
          color={direction2Chip[props.direction].stroke}
        />
      </Stack>
    </Stack>
  </Card>
);
